import { render, staticRenderFns } from "./EditDeal.vue?vue&type=template&id=dd691476&scoped=true"
import script from "./EditDeal.vue?vue&type=script&lang=js"
export * from "./EditDeal.vue?vue&type=script&lang=js"
import "./EditDeal.vue?vue&type=style&index=0&id=dd691476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd691476",
  null
  
)

export default component.exports